import { render, staticRenderFns } from "./MediaStats.vue?vue&type=template&id=8ccf65bc&lang=html&"
import script from "./MediaStats.vue?vue&type=script&lang=js&"
export * from "./MediaStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports